export default __webpack_public_path__ + "static/media/instagram.b5d67a97.svg";